import axios from "axios";
import AuthenticationInterceptors from "./authentication-interceptors";
import ErrorInterceptors from "./error-interceptors";

const ServiceRegistry = () => {
	const authenticatedServices = [];

	const createService = (baseUri, authenticationService) => {
		const serviceInstance = axios.create({
			baseURL: baseUri
		});

		if (authenticationService) {
			AuthenticationInterceptors.addTokenExpiredInterceptor(
				serviceInstance,
				authenticationService
			);
			authenticatedServices.push(serviceInstance);
		}

		ErrorInterceptors.addErrorInterceptor(serviceInstance);

		return serviceInstance;
	};

	return {
		createService
	};
};

export default ServiceRegistry();
